import type { JSX } from 'react'

import { useTranslation } from 'react-i18next'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { AuthLayout } from '~/widgets/auth'
import { FinalMessage } from '../../shared/ui'

export function Title(): JSX.Element {
  return <AppTitle t={['sign_up', 'success']} />
}

DonePage.displayName = 'DonePage'
export function DonePage(): JSX.Element {
  const { t } = useTranslation()
  const bodyMessagePart1 = t('confirm_successful_message')
  const bodyMessagePart2 = t('sign_in_offer_message')

  return (
    <AuthLayout>
      <FinalMessage
        title={t('confirm_title')}
        body={[bodyMessagePart1, bodyMessagePart2]}
        button={t('sign_in')}
        to='/sign-in'
      />
    </AuthLayout>
  )
}
